import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { announcements as annApi, type PublicArchive as PublicArchiveT } from '../api';

/** SCO-58 / SCO-60 — the no-login public announcement archive for one Unit. Date filter only. */
export function PublicArchive() {
  const { unitId = '' } = useParams();
  const [data, setData] = useState<PublicArchiveT | null>(null);
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    annApi
      .public(unitId, { from: from || undefined, to: to || undefined })
      .then(setData)
      .catch(() => setError(true));
  }, [unitId, from, to]);

  if (error) {
    return (
      <div className="legal-page">
        <h1>Not available</h1>
        <p className="muted">This page could not be loaded.</p>
      </div>
    );
  }
  if (!data) return <div className="legal-page"><p className="muted">Loading…</p></div>;

  if (!data.enabled) {
    return (
      <div className="legal-page">
        <h1>{data.unitName ?? 'Announcements'}</h1>
        <p className="muted">This pack hasn’t published a public announcements page.</p>
      </div>
    );
  }

  return (
    <div className="legal-page">
      <h1>{data.unitName} — Announcements</h1>
      <div className="row" style={{ gap: 12, flexWrap: 'wrap', alignItems: 'center', margin: '12px 0' }}>
        <label className="filter">
          From <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
        </label>
        <label className="filter">
          To <input type="date" value={to} onChange={(e) => setTo(e.target.value)} />
        </label>
        {(from || to) && (
          <button
            onClick={() => {
              setFrom('');
              setTo('');
            }}
          >
            Clear
          </button>
        )}
      </div>

      {data.posts.length === 0 ? (
        <p className="muted">No announcements.</p>
      ) : (
        data.posts.map((p) => (
          <article key={p.id} className="attribution-entry">
            <h2 style={{ marginBottom: 2 }}>{p.title}</h2>
            <p className="muted small">
              {p.authorName} · {new Date(p.publishedAt).toLocaleDateString()}
            </p>
            <p style={{ whiteSpace: 'pre-wrap' }}>{p.body}</p>
          </article>
        ))
      )}

      <p className="muted small" style={{ marginTop: 24 }}>
        Not affiliated with, endorsed by, or sponsored by Scouting America / the Boy Scouts of
        America. · <Link to="/about">About</Link>
      </p>
    </div>
  );
}
